import { render, staticRenderFns } from "./GoodsClassCollection.vue?vue&type=template&id=0096fb70&scoped=true"
import script from "./GoodsClassCollection.vue?vue&type=script&lang=js"
export * from "./GoodsClassCollection.vue?vue&type=script&lang=js"
import style0 from "./GoodsClassCollection.vue?vue&type=style&index=0&id=0096fb70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096fb70",
  null
  
)

export default component.exports